import { Input, type InputVariant } from '@mantine/core';
import { useEffect, useState, type ReactElement } from 'react';

interface Props {
  value: number;
  onChange: (value: number) => void;
  variant?: InputVariant;
}

const convertToString = (value: number): string => {
  const hours = Math.floor(value / 60);
  const minutes = Number(value) % 60;

  return `${hours}h ${minutes}m`;
};

export const HourMinuteInput = (props: Props): ReactElement => {
  const { value, onChange, variant } = props;
  const [inputValue, setInputValue] = useState<string>(convertToString(value));
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    setInputValue(convertToString(value));
  }, [value]);

  const convertToMinutes = (input: string) => {
    const regex = /^(\s*\d+h)?\s*(\d+m?)?$/;
    if (regex.test(input)) {
      setError(false);
      if (input.includes('h')) {
        const [hours, minutes] = input.split('h');
        return Number(hours) * 60 + Number(minutes.replace(/\D/g, ''));
      }
      return Number(input.replace(/\D/g, ''));
    } else {
      setError(true);
      return 0;
    }
  };

  const handleBlur = () => {
    setInputValue(convertToString(value));
    onChange(convertToMinutes(inputValue));
  };

  return (
    <Input
      value={inputValue}
      onChange={input => setInputValue(input.currentTarget.value)}
      onBlur={handleBlur}
      variant={variant}
      error={error}
    />
  );
};
